import React from 'react';
import './AccountDesktopNavigation.scss';
import Button from '../../../@redantler/redantler-npm-button-react';

/**
 * Renders the desktop version of the Account navigation
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const AccountDesktopNavigation = ({ customer, activeSection, setActiveSection }) => (
  <div className="c-account-desktop-navigation">
    <h2 className="c-account-desktop-navigation__heading h2-roobert">
      Welcome{customer.firstName ? `, ${customer.firstName}` : ''}
    </h2>
    <ul className="c-account-desktop-navigation__list body-2">
      <li
        className={`c-account-desktop-navigation__item ${
          activeSection === 'My Account' ? 'is-active' : ''
        }`}
      >
        <Button
          onClick={(e) => {
            setActiveSection(e.target.value);
            window.location = '/account';
          }}
          value="My Account"
        >
          My Account
        </Button>
      </li>
      <li
        className={`c-account-desktop-navigation__item ${
          activeSection === 'Order History' ? 'is-active' : ''
        }`}
      >
        <Button
          onClick={(e) => {
            setActiveSection(e.target.value);
          }}
          value="Order History"
        >
          Order History
        </Button>
      </li>
      <li className="c-account-desktop-navigation__item">
        <a href="/account/logout">Log Out</a>
      </li>
    </ul>
  </div>
);

export default AccountDesktopNavigation;
